<template>
  <div>
    <span class="logo" @click="$router.push({ name: 'Home' })" v-if="!menuVisible"></span>
    <iframe :src="track.embed" v-if="track.embed" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>

    <div class="col-lg-10 col-lg-offset-1 track-embed">
      <TrackEmbed :track="track" v-if="!track.embed" :login="login" />
    </div>

    <button type="button" class="close" @click="close"></button>
    <Share :track="track" class="share" />
  </div>
</template>

<script>
import TrackEmbed from '@/components/TrackEmbed'
import Share from '@/components/Share'

export default {
  name: 'Track',
  dependencies: ['DATA'],
  props: ['login'],
  components: {
    TrackEmbed,
    Share
  },
  data () {
    return {
      menuVisible: false
    }
  },
  methods: {
    showLogo (visible) {
      this.menuVisible = visible
    },
    close (evt) {
      evt.preventDefault();
      window.history.back();
    }
  },
  computed: {
    track () {
      let slug = this.$route.params['slug']
      let track = this.DATA.tracks.filter((track) => {
        return track.slug === slug
      })
      if (track.length) {
        return track[0]
      } else {
        return null
      }
    }
  },
  mounted () {
    if (this.track === null) {
      alert('Release not found.')
      this.$router.push({ name: 'Home' })
    } else {
      setTimeout(() => {
        window.scrollTo(0, 1)
      }, 0)
    }

    this.$bus.$emit('setColors', '#000', '#fff', '#fff')

    this.$bus.$on('menuVisible', (visible) => {
      this.showLogo(visible)
    })

    setTimeout(() => {
      window.scrollTo(0, 1)
    }, 0)
  }
}
</script>

<style scoped lang="scss">
@import '../../scss/variables';
.track-embed {
  padding-top: 60px;
}
button.close {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 40px;
  height: 40px;
  padding: 0;

  outline: none;
  background-color: transparent;
  background-size: 50% 50%;
  background-image: url('/static/images/close.svg');
  background-repeat: no-repeat;
  background-position: 50% 50%;
  transition: transform 0.3s $easeOutBack;
  z-index: 9;
  &:hover {
    transform: scale(1.1);
  }
  &:active {
    transform: scale(0.9);
  }

  display: none;
  @media screen and (max-width: 64em) {
    display: block;
    border: none;
    top: 3%;
  }
}
.share {
  position: fixed;
  right: 0;
  top: 120px;
  z-index: 2;
}
.logo {
  background-image: url('/static/images/logo2_black.svg');
  background-repeat: no-repeat;
  background-size: contain;
  width: 100px;
  height: 10vw;
  position: absolute;
  top: 25px;
  left: 45px;
  cursor: pointer;
  z-index: 4;
  @media screen and (max-width: 64em) {
    left: 50%;
    margin-left: -45px;
    top: 3%;
  }
}
nav {
  display: block;
  background: $black;
  padding: 20px 0;
  a {
      background-image: url('/static/images/logo.svg');
      background-repeat: no-repeat;
      background-size: contain;
      width: 150px;
      height: 64px;
      display: block;
      margin-top: 5px;
      margin-left: 40px;
      cursor: pointer;
      filter: invert(100%);
      @media screen and (max-width: 64em) {
        margin: 0 auto;
      }
  }
}
iframe {
  background: $white;
  display: block;
  width: 100%;
  height: 80vh;
  padding-top: 80px;
}
</style>



// WEBPACK FOOTER //
// src/pages/track/index.vue